import { createGlobalStyle } from 'styled-components';
import reset from 'react-style-reset';

import './fonts.css';

const GlobalStyle = createGlobalStyle`
  ${reset};

  *::placeholder {
    color: ${props => props.theme.colors.grey};
    font-size: ${props => props.theme.font.smallSize};
    opacity: 0.5;
    /* line-height: 100px; */
    font-weight: 400;
    font-style: italic;
    height: 100%;
}

  html, body {
    height: 100%;
  }

  body {
    /* font-family: 'Encode Sans', sans-serif; */
    font-family: 'Chalkduster', 'Helvetica';
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.darkBlue};
    font-size: ${props => props.theme.font.normalSize};
    overflow: hidden;
    height: ${({ bodyHeight }) => bodyHeight && bodyHeight + 'px'};
    min-width: 320px;
    max-height: 1080px;
    /* max-width: 1980px;
    max-height: 1080px; */
  }

  img {
    width: 100%;
  }

  h1, h2, h3, h4, h5, p, span {
    line-height: 1.33;
  }

  /* clears the 'X' from Internet Explorer */
input[type=search]::-ms-clear {  display: none; width : 0; height: 0; }
input[type=search]::-ms-reveal {  display: none; width : 0; height: 0; }

/* clears the 'X' from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration { display: none; }


`;

export default GlobalStyle;
